import styled, { css } from 'styled-components';
import { breakpoint } from 'styles/globals';
import { getBodyStyle, type Theme } from 'styles/theme';
import { blueSecondaryLink } from 'components/Globals/Base/Link/LinkStyles';

export const Container = styled.div`
  padding: 0 20px;

  

  @media (${breakpoint.mdMin}) {
    padding: 0 8px;
  }

  @media (${breakpoint.xlMin}) {
    padding: 0;
  }
`;

const customIframeStyles = css`
  margin: 0;
`;

export const ContentWrapper = styled.div<{ theme: Theme; $templateType: string }>`
  ${getBodyStyle('georgia', { default: 'default' })};

  p {
    margin: 24px 0;
  }

  // Restore list styling for branded articles
  ul, ol {
    list-style: revert;
    padding: revert;
    margin: revert;
  }

  @media(${breakpoint.mdMin}) {
    max-width: 704px;
    margin: 24px auto;
    ${({ $templateType }) => $templateType === 'custom-iframe' && customIframeStyles}
  }

  @media(${breakpoint.lgMin}) {
    max-width: 633px;
    margin-top: 48px;
    ${({ $templateType }) => $templateType === 'custom-iframe' && customIframeStyles}
  }

  a {
    ${blueSecondaryLink}
  }
`;
